import {Component} from '@angular/core';

@Component({
  selector: 'vui-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent {

}
